/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon20Regular = forwardRef('ArrowALeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.812 16.032a.75.75 0 1 1-1.06 1.06l-5.238-5.236a2.625 2.625 0 0 1 0-3.712l5.237-5.237a.75.75 0 1 1 1.06 1.06L3.576 9.205c-.015.015-.03.03-.043.046H17.5a.75.75 0 0 1 0 1.5H3.532l.043.045 5.237 5.237Z" })));
});
